import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { DetailSubsection } from '@periscopes/general';
import React from 'react';
import { SonarObjectStakeholders } from '@ui/general';

export interface BusinessContextStakeholderProps {
	sonarObjectId: number;
}

export const BusinessContextStakeholder: React.FC<BusinessContextStakeholderProps> = ({ sonarObjectId }) =>
	<DetailSubsection title={ COPY_SPECIFIC.STAKEHOLDERS }>
		<SonarObjectStakeholders
			direction='horizontal'
			sonarObjectId={ sonarObjectId }
			withLatest />
	</DetailSubsection>;

